import { useState, useEffect } from "react";

import { getFirebaseAssetURL } from "utils/getFirebaseAssetURL";

interface TResolved {
  path: string;
  url: string;
}

/**
 * Přeloží cestu ve Firebase Storage na stahovatelnou URL.
 *
 * AIDEV-NOTE: Efekt musí viset na `assetPath`, ne na prázdném poli. Hook se běžně volá nad
 * podmíněným renderem (BookExam, ExamIntro), kde kniha při prvním běhu ještě není z API
 * načtená — s `[]` by cestu přečetl jen při mountu a zůstal navždy `null`. Přesně tahle past
 * shodila pracovní list ve zkoušení nanečisto. [TD-333]
 */
export const useAssetUrlResolver = (assetPath: string | null | undefined) => {
  // Cesta se drží u URL: po přepnutí knihy tak ani jediný render nevrátí URL té předchozí
  // (u pracovního listu by to znamenalo nabídnout ke stažení cizí PDF).
  const [resolved, setResolved] = useState<TResolved | null>(null);

  useEffect(() => {
    if (typeof assetPath !== "string" || assetPath.length === 0) return undefined;

    // Kniha se mezitím může vyměnit (jiné id v URL) — pozdní odpověď nesmí přepsat novější.
    let isCurrent = true;

    getFirebaseAssetURL(assetPath)
      .then(url => {
        if (!isCurrent || url === undefined) return;
        setResolved({ path: assetPath, url });
      })
      .catch(console.error);

    return () => {
      isCurrent = false;
    };
  }, [assetPath]);

  return resolved !== null && resolved.path === assetPath ? resolved.url : null;
};
